import React from 'react';
import PropTypes from 'prop-types';
import Label from '../label/label';

const Dropdown = ({
  className,
  formId,
  id,
  validations,
  defaultValue,
  defaultLanguage,
  label,
  setValue,
}) => {
  if (!validations) return null;
  const isRequired = validations && validations.required ? true : false;
  const ddValues =
    validations &&
    validations.allowedValues &&
    validations.allowedValues.values;

  if (!ddValues || ddValues.length < 1) return null;
  return (
    <div className="dropdown-container">
      <Label
        id={id}
        label={label}
        isRequired={isRequired}
        className="label-dropdown"
      />
      <select
        name={id}
        id={id}
        className={`${className ? className : ''} select-dropdown`}
        defaultValue={defaultValue}
        onBlur={e => {
          setValue(formId, id, e.target.value);
        }}
      >
        {ddValues.map((val, idx) => {
          return (
            <option
              key={`${val[defaultLanguage]}-${idx}`}
              value={val[defaultLanguage]}
              className="option-dropdown"
            >
              {val[defaultLanguage]}
            </option>
          );
        })}
      </select>
    </div>
  );
};

Dropdown.propTypes = {
  className: PropTypes.string,
  formId: PropTypes.string,
  setValue: PropTypes.func,
  id: PropTypes.string,
  validations: PropTypes.object,
  defaultValue: PropTypes.string,
  label: PropTypes.string,
  defaultLanguage: PropTypes.string,
};

export default Dropdown;
